// entityApi.ts
import axios from './axiosSetup3'
import { AxiosRequestConfig } from 'axios';
import { Entity } from "../types/entity";

const get = async (param: {type: number} ): Promise<Entity[]> => {
    const res = await axios.get<Entity[]>(`/lpr_entity?type=eq.${param.type}`);
    return res.data;
};

const getParents = async (param: {type: number} ): Promise<Entity[]> => {
    const res = await axios.get<Entity[]>(`/lpr_entity?type=eq.${param.type}`);
    return res.data;
};

const delete_ = async (entity_id: number): Promise<void> => {
    await axios.delete<Entity>(`/lpr_entity?entity_id=eq.${entity_id}`);
}
const post = async (data: Entity): Promise<Entity> => {
    const { entity_id: omit, ...entity } = data;
    const config: AxiosRequestConfig = {
        headers: {
            'Prefer': 'return=representation'
        }
    };    
    
    const res = await axios.post<Entity>('/lpr_entity', entity, config);

    if (res.status !== 201) return {} as Entity;

    const createdEntity = Array.isArray(res.data) ? res.data[0] : res.data;

    if (!createdEntity || !createdEntity.entity_id) {
        // Дополнительная проверка на случай, если тело ответа все равно пустое
        return {} as Entity; 
    }
    
    return createdEntity;    
}

const put = async (data: Entity): Promise<Entity> => {
    const res = await axios.put<Entity>(`/lpr_entity?entity_id=eq.${data.entity_id}`, data);
    return res.status === 204 ? data : {} as Entity;
}

export interface CustomerQuota {
    customer_id: number;
    entity_id: number;
    name: string;
    max_parking_slots?: number;
    max_permits?: number;
    occupied_parking_slots?: number;
    ts_update?: string;
}

interface PostgrestEntityResponse {
    customer_id: number;
    entity_id: number;
    name: string;
    lpr_customer_to_entity: Array<{
        max_parking_slots: number | null;
        max_permits: number | null;
        occupied_parking_slots: number | null;
        ts_update: string | null;
    }>;
}

const getQuotas = async (): Promise<CustomerQuota[]> => {
    const res = await axios.get<PostgrestEntityResponse[]>(
        '/lpr_entity?select=customer_id,entity_id,name,lpr_customer_to_entity(max_parking_slots,max_permits,occupied_parking_slots,ts_update)&type=eq.1'
    );
    
    return res.data.map(({ lpr_customer_to_entity, ...entity }) => {
        // Достаем первый элемент из массива (аналог LEFT JOIN)
        const cte = lpr_customer_to_entity?.[0]; 
        
        return {
            ...entity, // Сюда автоматически попадут customer_id, entity_id, name
            max_parking_slots: cte?.max_parking_slots ?? undefined,
            max_permits: cte?.max_permits ?? undefined,
            occupied_parking_slots: cte?.occupied_parking_slots ?? undefined,
            ts_update: cte?.ts_update ?? undefined
        };
    });
};

const upsertQuotaRow = async (data: CustomerQuota): Promise<boolean> => {
    const { name, ...rest } = data;
    const payload = {
        customer_id: data.customer_id,
        entity_id: data.entity_id,
        max_parking_slots: data.max_parking_slots ? Number(data.max_parking_slots) : undefined,
        max_permits: data.max_permits ? Number(data.max_permits) : undefined,
        occupied_parking_slots: data.occupied_parking_slots ? Number(data.occupied_parking_slots) : undefined,
        ts_update: data.ts_update
    };
    const url = '/lpr_customer_to_entity?on_conflict=customer_id,entity_id';
    try {
        const res = await axios.post(url, payload, {
            headers: {
                'Prefer': 'resolution=merge-duplicates' 
            }        
        });
        return true;
    } catch (error: any) {
        console.error("Ошибка при обновлении квоты:", error);
        console.error("Детали ошибки:", error.response?.data);
        return false;
    }
};

interface ActionResult {
    result: boolean;
    message: string;
}

const trigger_camera_dry_contact = async (entity_id: number): Promise<ActionResult> => {
    try {
        const res = await axios.post<ActionResult>(`/rpc/sf_trigger_camera_dry_contact`, {entity_id});
        return res.status === 200 ? res.data : { result: false, message: 'unknown error' };
    } catch (error: any) {
        return { 
            result: false, 
            message: error?.isAxiosError ? error.message : 'network error' 
        };
    }
};


export const api = {
    get,
    getParents,
    post,
    put,
    delete: delete_,
    getQuotas,
    upsertQuotaRow,
    trigger_camera_dry_contact,
};